export default __webpack_public_path__ + "static/media/onedrive-icon.70574dfa.png";